import PropTypes from 'prop-types';
import Button from './Button';
import Modal from './Modal';

function EditModal({
  open,
  title,
  message,
  setNewCostImpact,
  onConfirm,
  onCancel,
}) {
  if (!open) {
    return null;
  }
  return (
    <Modal>
      <Modal.Title title={title} />
      <Modal.Message message={message} />

      <input
        type="number"
        placeholder="Enter cost impact"
        onChange={e => setNewCostImpact(e.target.value)}
        className="mb-4 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#1F305E]"
      />
      <Modal.ButtonRow>
        <Button type="cancel" onClick={onCancel} message="Cancel" />
        <Button type="primary" onClick={onConfirm} message="Confirm" />
      </Modal.ButtonRow>
    </Modal>
  );
}
EditModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  setNewCostImpact: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default EditModal;
